import { render, staticRenderFns } from "./passo2.vue?vue&type=template&id=6b36833a&scoped=true&"
import script from "./passo2.vue?vue&type=script&lang=js&"
export * from "./passo2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36833a",
  null
  
)

export default component.exports